import { z } from 'zod';

/**
 * Zod schema for Hub (Vite) environment variables.
 * Validated at application startup in main.tsx.
 */
export const envSchema = z.object({
  NODE_ENV: z.string().optional(),
  VITE_PROJECT: z.string().min(1),
  VITE_APP_ENV: z.string().min(1),
  VITE_API_END_POINT: z.string().min(1),
  VITE_PUSHER_API_KEY: z.string().min(1),
  VITE_PUSHER_CLUSTER: z.string().min(1),
  VITE_LEADDYNO_PUBLIC_KEY: z.string().min(1),
  VITE_AWS_REGION: z.string().min(1),
  VITE_COGNITO_POOL_NAME: z.string().min(1),
  VITE_AWS_CLIENT_ID: z.string().min(1),
  VITE_CDN_BASE_URL: z.string().optional(),
  VITE_DOMAIN_NAME: z.string().optional(),
  VITE_CLOUDINARY_FOLDER: z.string().optional(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_GTM_ID: z.string().optional(),
  VITE_MIXPANEL_TOKEN: z.string().optional(),
  VITE_RECAPTCHA_SITE_KEY: z.string().optional(),
  VITE_GA_ID: z.string().optional(),
  VITE_PAYSAFE_PUBLIC_KEY: z.string().min(1),
  VITE_PAYSAFE_ENV: z.string().optional(),
  VITE_FEATURE_FLAG_API_HOST: z.string().min(1),
  VITE_FEATURE_FLAG_CLIENT_KEY: z.string().min(1),
  VITE_S3_BASE_URL: z.string().min(1),
  VITE_S3_BASE_ENABLED: z.string().optional(),
  VITE_HUB_NEXT_URL: z.string().optional(),
  VITE_FF_CACHE_INTERVAL: z.string().optional(),
  VITE_DESCOPE_PROJECT_ID: z.string().optional(),
  VITE_SENTRY_ORG: z.string().optional(),
  VITE_DESCOPE_CUSTOM_DOMAIN: z.string().optional(),
  VITE_HUB_AWS_USER_POOL_DOMAIN: z.string().optional(),
  VITE_CHART_FEED_TOKEN: z.string().optional(),
  VITE_META_TAG_TITLE: z.string().optional(),
  VITE_META_TAG_DESCRIPTION: z.string().optional(),
  VITE_META_TAG_IMAGE: z.string().optional(),
  VITE_USERCENTRICS_CBID: z.string().optional(),
  VITE_FACEBOOK_PIXEL_THE5_ID: z.string().optional(),
  VITE_FACEBOOK_PIXEL_TTP_ID: z.string().optional(),
  VITE_CORALOGIX_RUM_PUBLIC_KEY: z.string().optional(),
  VITE_CORALOGIX_RUM_DOMAIN: z.string().optional(),
  VITE_VERSION: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_ERRORS: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_FETCH: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_XHR: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_CUSTOM: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_LONG_TASKS: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_RESOURCES: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_INTERACTIONS: z.string().optional(),
  VITE_CORALOGIX_RUM_INSTR_WEB_VITALS: z.string().optional(),
});

export type EnvConfig = z.infer<typeof envSchema>;
